<template>
  <div>
    <CButton @click="openAddress">获取用户地址信息</CButton>
    <CButton @click="chooseInvoiceTitle">获取用户发票信息</CButton>
    <div>--------------</div>
    <CButton @click="chooseImage2">选择图片(2)</CButton>
  </div>
</template>

<script>
import CButton from "@/components/common/CButton.vue";
import {
  chooseInvoiceTitle,
  openAddress,
  chooseWxImage,
  uploadWxImage,
  chooseDomImage,
} from "@/utils";

export default {
  components: {
    CButton,
  },
  methods: {
    async openAddress() {
      try {
        const res = await openAddress();
        console.info("openAddress res", res);
      } catch (error) {
        console.error("openAddress error", error);
        if (error?.message) this.$toast(error.message);
      }
    },

    async chooseInvoiceTitle() {
      try {
        const info = await chooseInvoiceTitle();
        console.log("chooseInvoiceTitle info", info);
      } catch (error) {
        console.error("chooseInvoiceTitle error", error);
        if (error?.message) this.$toast(error.message);
      }
    },
    async uploadImage() {
      try {
        const { localIds } = await chooseWxImage();
        console.log("uploadImage localIds", localIds);
        const { serverId } = await uploadWxImage(localIds[0]);
        console.log("uploadImage serverId", serverId);
      } catch (error) {
        console.error("uploadImage error", error);
        if (error?.message) this.$toast(error.message);
      }
    },
    async chooseImage2() {
      try {
        const files = await chooseDomImage();
        console.log("chooseImage2 files", files);
      } catch (error) {
        console.error("chooseImage2 error", error);
        if (error?.message) this.$toast(error.message);
      }
    },
  },
};
</script>
